import React, { useState } from "react";
import { Redirect, Route, RouteProps } from "react-router";
import AppModal from "../../modal/AppModal";
import { useAuth } from "../../providers/AuthProvider";

interface ProtectedRouteProps extends RouteProps {
  component?: React.ComponentType<any>;
  allowedRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  component: Component,
  allowedRoles,
  ...rest
}) => {
  const { isAuthenticated, roles, isLoading } = useAuth();
  const [showErrorModal, setShowErrorModal] = useState<boolean>(true);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isLoading) return null;

        if (!isAuthenticated) {
          return <Redirect to="/" />;
        }

        const hasRole =
          !allowedRoles ||
          allowedRoles?.length === 0 ||
          allowedRoles?.some((role) => roles?.includes(role));

        if (!hasRole) {
          return (
            <AppModal
              open={showErrorModal}
              onClose={() => setShowErrorModal(false)}
              title="Access Denied"
            >
              <p>User does not have privileges to access this page.</p>
            </AppModal>
          );
        }

        return Component ? <Component {...props} /> : null;
      }}
    />
  );
};

export default ProtectedRoute;
